import {StepSection} from '../StepSection'
import {Subheader} from '../../../../../../genericComponents/typographie/UIKitV2/Subheader'
import {AddedFiles, AddFileField, DateField, SectionWithSwitch, SelectField, TextWithTooltip} from './SharedComponents'
import {Button} from '@mui/material'
import {Label} from '../../../../../../genericComponents/typographie/Label'
import './SharedComponents.scss'
import {FieldArray, getIn, useFormikContext} from 'formik'
import {
    EnvironmentalRegulationTypes,
    ExportControlClassificationTypes,
    ItemCreationForm,
    ServiceFields
} from '../../../../../model/NewItemInput'
import {Add} from '@mui/icons-material'
import CustomSwitch from '../../../../../../genericComponents/customSwitch/CustomSwitch'

const EndOfLifeStatusComponent = () => {
    return <SectionWithSwitch label="End of Life Status" tooltip="Declare Last Buy Order status"
                              target={`${ServiceFields.EndOfLifeStatus}`}>
        <div className="service-form-section">
            <div className="service-form-row">
                <div className="service-form-field">
                    <Label htmlFor={`${ServiceFields.EndOfLifeStatus}.date`}>Last buy order (LBO) date</Label>
                    <DateField target={`${ServiceFields.EndOfLifeStatus}.date`}/>
                </div>
                <AddFileField target={`${ServiceFields.EndOfLifeStatus}.proofs`} title="Upload LBO Evidence"/>
            </div>
            <AddedFiles target={`${ServiceFields.EndOfLifeStatus}.proofs`}/>
        </div>
    </SectionWithSwitch>
}

const ExportControlClassificationComponent = () => {
    return <SectionWithSwitch label="Export Control Classification" tooltip="Declare ECC regulation and/or classification Eg. Double Usage, Military, EAR, etc"
                              target={`${ServiceFields.ExportControlClassification}`}>
        <div className="service-form-section">
            <div className="service-form-row">
                <div className="service-form-field">
                    <Label htmlFor={`${ServiceFields.ExportControlClassification}.type`}>Export Control Classification Type</Label>
                    <SelectField target={`${ServiceFields.ExportControlClassification}.type`}
                                 placeholder="Select Control Classification Type"
                                 options={Object.values(ExportControlClassificationTypes)}/>
                </div>
                <AddFileField target={`${ServiceFields.ExportControlClassification}.proofs`}
                              title="Upload Classification Evidence"/>
            </div>
            <AddedFiles target={`${ServiceFields.ExportControlClassification}.proofs`}/>
        </div>
    </SectionWithSwitch>
}

const AddEnvironmentRegulation = ({onAdd, canAdd}: { onAdd: () => void, canAdd: boolean }) => {
    return <Button variant="text" disabled={!canAdd} onClick={onAdd} startIcon={<Add/>}>
        <Subheader>Add Environmental Regulation</Subheader>
    </Button>
}

const EnvironmentalRegulation = () => {
    const formik = useFormikContext<ItemCreationForm>()
    const regulations = formik.values[ServiceFields.EnvironmentalRegulation] ?? []
    const lastAddedRegulation = regulations.length > 0 ? regulations[regulations.length - 1] : undefined
    const allRegulations = Object.values(EnvironmentalRegulationTypes)
    
    const regulationDetail = (index: number) => {
        return <div className="service-form-section">
            <div className="service-form-row">
                <div className="service-form-field">
                    <Label htmlFor={`${ServiceFields.EnvironmentalRegulation}[${index}].type`}>Environmental Regulation Type</Label>
                    <SelectField target={`${ServiceFields.EnvironmentalRegulation}[${index}].type`}
                                 placeholder="Select Environmental Regulation Type"
                                 options={allRegulations.filter(reg => !formik.values[ServiceFields.EnvironmentalRegulation].map(v => v.type).includes(reg))}/>
                </div>
                <AddFileField target={`${ServiceFields.EnvironmentalRegulation}[${index}].proofs`}
                              title="Upload Environmental Regulation Evidence"/>
            </div>
            <AddedFiles target={`${ServiceFields.EnvironmentalRegulation}[${index}].proofs`}/>
        </div>
    }
    return <SectionWithSwitch label="Environmental Regulation" tooltip="Declare environmental status and/or regulations EG. ROHS, REACH, CLP"
                              target={`${ServiceFields.EnvironmentalRegulation}`}>
        <div className="added-regulations">
            {regulations.length === 0
                ? <>{regulationDetail(0)}</>
                : regulations.map((_, index) => regulationDetail(index))
            }
        </div>
        <FieldArray name={ServiceFields.EnvironmentalRegulation} render={({push}) => (<>
            <AddEnvironmentRegulation onAdd={() => push({type: undefined, proofs: []})}
                                      canAdd={Boolean(regulations.length && lastAddedRegulation?.type && regulations.length < allRegulations.length)}/>
        </>)}/>

    </SectionWithSwitch>
}



export const AdditionalInformationSection = () => {
    return <StepSection title="Additional information"
                        description="Complete additional information based on the data at your disposal">
        <EndOfLifeStatusComponent/>
        <ExportControlClassificationComponent/>
        <EnvironmentalRegulation/>

    </StepSection>
}

